export const NAV = [
  { to: "/", label: "Home", end: true, id: "home" },
  { to: "/used-cars", label: "Used Cars", id: "used-cars" },
  { to: "/about", label: "About Us", id: "about" },
  { to: "/reviews", label: "Reviews", id: "reviews" },
  { to: "/contact", label: "Contact", id: "contact" },
];
